import { render, staticRenderFns } from "./RolesForm.vue?vue&type=template&id=0f3e65ed&scoped=true"
import script from "./RolesForm.vue?vue&type=script&lang=js"
export * from "./RolesForm.vue?vue&type=script&lang=js"
import style0 from "./RolesForm.vue?vue&type=style&index=0&id=0f3e65ed&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f3e65ed",
  null
  
)

export default component.exports